import { render, staticRenderFns } from "./modulegroups.vue?vue&type=template&id=757896e0&"
import script from "./modulegroups.vue?vue&type=script&lang=js&"
export * from "./modulegroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports